import {Injectable} from '@angular/core';
import {UiControl} from '../models/uiControl';
import {EventService} from './event.service';
import {BooleanControl, flatMap} from '../models/uiArtefakt';
import {UiModelService} from './ui-model.service';
import {UIArtefaktTyp} from '../models/uiArtefaktTyp';

@Injectable()
export class RisikofragenService{

  private _uiControl: UiControl;

  public constructor(private _eventService: EventService, private _uiModelService: UiModelService) {
    this._eventService.uiControls$.subscribe(uiControl => this._uiControl = uiControl);
  }

  public setEmptyQuestionsFalse(){
    flatMap(this._uiControl.uiVorgang.UIArtefakt)
    .filter((artefakt: BooleanControl) => !!artefakt.RisikofrageJN && artefakt.UIArtefakttyp === UIArtefaktTyp.BOOLEAN)
    .forEach(artefakt => artefakt.WertEingabe = false);
    this._uiModelService.requestUiControl(this._uiControl).subscribe();
  }
}
